import React, { useState } from "react";
import NavbarCart from "../cart/NavbarCart";
import NavbarSearch from "../cart/NavbarSearch";
import NavbarScanner from "../cart/NavbarScanner";

const Navbar = ({ onSearchClick, onScanClick, openModal, paymentMode }) => {
  return (
    <div className="sm:hidden z-50 fixed bottom-0 left-0 right-0 flex justify-around items-center px-4 py-2 bg-transparent shadow-md md:px-8 md:py-4">
      <NavbarSearch onSearchClick={onSearchClick} />
      <NavbarScanner onScanClick={onScanClick} />
      <NavbarCart openModal={openModal} paymentMode={paymentMode} />
    </div>
  );
};

export default Navbar;
